<template>
  <div style="min-width: 1100px; width: 55%; padding: 40px 20px 30px 20px; margin: 0 auto;">
    <H1 style="margin-top: 20px">热门问答</H1>
    <el-table class="no-line-table"  style="margin-left: -5px; margin-top: 10px" :data="hotTicketList"
              :show-header="false"
              :row-style="{ height: '50px' }"
              :header-cell-style="{ background: 'transparent', color: 'transparent' }"
              @row-click="clickRow">
      <el-table-column prop="title">
        <template slot-scope="scope">
          <label>{{scope.row.title}}</label>
          <div style="float: right">
            <span>{{typeDesc(scope.row.type)}}</span>
            <el-divider  direction="vertical"></el-divider>
            <span>{{tagDesc(scope.row.tag)}}</span>
          </div>
        </template>typeDesc
      </el-table-column>
    </el-table>
    <el-pagination style="float: right; margin-bottom: 20px"
                   class="paging"
                   @size-change="handleSizeChange"
                   @current-change="handlePageChange"
                   :page-sizes="[10, 50, 100, 200]"
                   :current-page.sync="pageNo"
                   :page-size="pageSize"
                   :total="total"
                   :hide-on-single-page="this.total <= 0"
                   layout="prev, pager, next, total">
    </el-pagination>
    <el-drawer size="40%" :visible.sync="showDetail" direction="rtl">
      <div>
        <hot-ticket-detail :id="selectedId"></hot-ticket-detail>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import HotTicketDetail from "./hot-ticket-detail";
export default {
  name: "hot-tickets",
  components: {HotTicketDetail},
  data() {
     return {
       hotTicketList: [],
       total: 0,
       pageNo: 1,
       pageSize: 10,
       showDetail: false,
       selectedId: null,
     }
  },

  mounted() {
    this.getList();
  },

  methods: {
    clickRow(row, column, event) { // 跳转到工单详情页
      if (row.id !== undefined) {
        this.selectedId = row.id
        this.showDetail = true;
      }
    },

    handlePageChange() {
      this.getList();
    },

    handleSizeChange() {
      this.pageNo = 1;
      this.getList();
    },

    tagDesc(tag) {
      return this.$config.ticketTagMap[tag].label;
    },

    typeDesc(type) {
      return this.$config.ticketTypeMap[type].label;
    },

    getList() {
      this.showCommonLoading();
      this.$axios.post('/ajax/doc/search/hot/list', {
        page_no: this.pageNo,
        page_size: this.pageSize
      }).then(res => {
        this.hideCommonLoading();
        if (res.data.ret === 0) {
          let content = res.data.data;
          this.total = content.total;
          this.hotTicketList = content.list;
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.no-line-table {
  .el-table th, .el-table tr,.el-table td{
    border: 0;
    background-color: transparent;
  }
  /* 去掉上面的线 */
  /deep/ .el-table th.is-leaf{
    border: none;
  }

  /deep/ .el-table__row:nth-child(2n) {
    background: transparent;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/ticket/hot-tickets.vue